import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { styles } from '../constants';

import { connect } from 'react-redux';
import { View, Alert, BackHandler } from 'react-native';
import { Text } from "native-base";
import BlockText from './BlockText';
import BlockSelect from './BlockSelect';
import BlockTreeSelect from './BlockTreeSelect';
import BlockButton from './BlockButton';
import BlockInput from './BlockInput';
import BlockList from './BlockList';
import BlockCheckbox from './BlockCheckbox';
import BlockRadiobutton from './BlockRadiobutton';
import BlockResultBlock from './BlockResultBlock';
import BlockAccordion from './BlockAccordion';
import BlockSearch from './BlockSearch';
import BlockSubTitle from './BlockSubTitle';

import { openURL } from '../_helpers';

import {
  setAlert,
  setDialog,
  getBlockByUrl,
  updateUserData,
  goBack,
  restartPoll
} from '../actions';

class ComponentRouter extends Component {
  state = {
    visible: false,
    code: '',
    email: ''
  };

  hasValue = () => {
    const { userData } = this.props;
    let hasValue = false;

    userData.blocks.forEach(block => {
      if (block.type !== 'BUTTON' && block.type !== 'EMPTY' && block.value && block.value.length) {
        hasValue = true;
      }
    });

    return hasValue;
  }

  hasRequiredValues = () => {
    const { userData } = this.props;
    let hasRequiredValues = true;

    // console.log(userData.blocks);

    userData.blocks.forEach(block => {
      if (
        block.type !== 'BUTTON' &&
        (!block.value || !block.value.length || (block.value.length === 1 && block.value[0] === ""))
        && block.required
      ) {
        hasRequiredValues = false;
      }

      // отдельно проверяем пустые блоки, если пустой блок reqired, то хотя бы что-то внутри должно быть заполнено
      if (block.type === 'EMPTY') {
        hasRequiredValues = true;

        block.elements.map(element => {
          element.blocks.forEach(block => {
            if (
              block.type !== 'BUTTON' &&
              (!block.value || !block.value.length || (block.value.length === 1 && block.value[0] === ""))
              && block.required
            ) {
              hasRequiredValues = false;
            }
          });
        });
      }
    });

    return hasRequiredValues;
  }

  hasSelectors = () => {
    const { userData } = this.props;
    let hasSelectors = false;

    userData.blocks.forEach(block => {
      if (block.type === 'CHECKBOX' || block.type === 'RADIOBUTTON') {
        hasSelectors = true;
      }
    });

    return hasSelectors;
  }

  hasRequiredFields = () => {
    const { userData } = this.props;
    let hasRequiredFields = false;

    userData.blocks.forEach(block => {
      if (block.required && block.type !== 'BUTTON') {
        hasRequiredFields = true;
      }
    });

    return hasRequiredFields;
  }

  getButtonLabel = () => {
    const { userData } = this.props;
    let disabled = false;

    userData.blocks.forEach(block => {
      if (block.required && block.type !== 'BUTTON' && (block.value === undefined || block.value.length === 0)) {
        disabled = true;
      }
    });

    return disabled;
  }

  checkAction = ({ element }) => {
    const { dispatch } = this.props;
    const action = element.action || {};

    switch (action.type) {

      case 'getBlock':
        if (action.url) {
          dispatch(getBlockByUrl(action.url));
        } else {
          dispatch(setAlert([{ 'message': 'Не указан путь запроса' }]));
        }
        return '';

      case 'goBack':
        this.backAction();
        return '';

      case 'restartPoll':
        this.props.dispatch(restartPoll());
        return '';

      case 'openUrl':
        openURL(action.url);
        return '';

      case 'openWindow':
        // if (Platform.OS === 'web') {
        this.props.dispatch(setDialog(element.label, element.value));
        // } else {
        //   Alert.alert(
        //     element.label,
        //     element.value,
        //     [
        //       {
        //         text: 'OK',
        //         onPress: () => console.log('OK ButtonPressed')
        //       },
        //     ]
        //   );
        // }
        break;

      default:
        return false;
    }
  }

  handlerChangeValue = ({ block, element, value, label }) => {
    const { dispatch } = this.props;

    if (value !== undefined) {
      if (!Array.isArray(value)) {
        value = ["" + value];
      }
      const name = block.name || '';
      dispatch(updateUserData({ name, value, label }));
    }

    if (element && element.action) {
      this.checkAction({
        block,
        element
      });
    }
  }

  backAction = () => {
    const { dispatch, history } = this.props;

    if (history.length > 1) {
      dispatch(goBack());
    } else {
      Alert.alert("", "Закрыть приложение?", [
        {
          text: "Отмена",
          onPress: () => null,
          style: "cancel"
        },
        {
          text: "Закрыть",
          onPress: () => BackHandler.exitApp()
        }
      ]);
    }

    return true;
  };

  renderBlock(block, i) {
    const { history } = this.props;

    let value;
    let renderBlock;
    let disabled;
    let visible = true;
    let label = "";
    let shitfix = false;

    if (block.type === 'CHECKBOX') {
      value = block.value || [];
    } else {
      value = block.value || [''];
      value = value[0];
    }

    switch (block.type) {
      case 'TEXT':
        renderBlock = <BlockText block={block} />;
        break;

      case 'SUB_TITLE':
        renderBlock = <BlockSubTitle block={block} />;
        break;

      case 'SELECT':
        renderBlock = <BlockSelect block={block} value={value} onChange={this.handlerChangeValue} />;
        break;

      case 'TREE_SELECT':
        renderBlock = <BlockTreeSelect block={block} value={value} onChange={this.handlerChangeValue} />;
        break;

      case 'BUTTON':
        if (history.length === 1) {
          visible = false;
        }
        console.log("this.hasRequiredFields() ", this.hasRequiredFields());
        console.log("this.hasRequiredValues() ", this.hasRequiredValues());
        if (this.hasRequiredFields() && !this.hasRequiredValues()) {
          disabled = true;
        }

        if (!disabled && !this.hasValue() && this.hasSelectors()) {
          label = "Ничего из вышеперечисленного";
          shitfix = true;
        }

        renderBlock = <BlockButton visible={visible} block={block} value={value} shitfix={shitfix} disabled={disabled} label={label} onChange={this.handlerChangeValue} />;
        break;

      case 'LIST':
        renderBlock = <BlockList key={i} block={block} value={value} onChange={this.handlerChangeValue} />;
        return renderBlock;

      case 'ACCORDION':
        renderBlock = <BlockAccordion key={i} block={block} value={value} expanded={1} onChange={this.handlerChangeValue} />;
        return renderBlock;

      case 'ACCORDION_COLLAPSED':
        renderBlock = <BlockAccordion key={i} block={block} value={value} expanded={0} onChange={this.handlerChangeValue} />;
        return renderBlock;

      case 'RESULT_BLOCK':
        renderBlock = <BlockResultBlock key={i} block={block} value={value} onChange={this.handlerChangeValue} />;
        return renderBlock;

      case 'CHECKBOX':
        renderBlock = <BlockCheckbox block={block} value={value} onChange={this.handlerChangeValue} />;
        break;

      case 'RADIOBUTTON':

        renderBlock = <BlockRadiobutton block={block} value={value} onChange={this.handlerChangeValue} />;

        break;

      case 'INPUT':
        renderBlock = <BlockInput block={block} value={value} onChange={this.handlerChangeValue} />;
        break;

      case 'SEARCH':
        renderBlock = <BlockSearch block={block} value={value} onChange={this.handlerChangeValue} />;
        break;

      case 'NUMBER':
        renderBlock = <BlockInput block={block} value={value} keyboardType="numeric" onChange={this.handlerChangeValue} />;
        break;

      default:
        renderBlock = <Text>{block.type}</Text>;
        break;
    }

    return renderBlock;
  }

  render() {
    const { block } = this.props;

    let blockStyle;
    if (block.type === "TEXT") {
      blockStyle = styles.containerText;
    } else if (block.type === "BUTTON") {
      blockStyle = styles.containerButton;
    } else if (block.type === "ACCORDION" || block.type === "ACCORDION_COLLAPSED") {
      blockStyle = styles.containerText;
    } else {
      blockStyle = styles.container;
    }

    return (
      <View style={blockStyle}>
        {
          block.type === "EMPTY" ? <>
            {block.elements.map(element => {
              return element.blocks.map(b => {
                return this.renderBlock(b);
              });
            })}
          </> :
            this.renderBlock(block)
        }
      </View>
    );
  }
}

function mapStateToProps(state) {
  return {
    userData: state.userData,
    history: state.history,
    alerts: state.alerts,
    currentAction: state.currentAction
  };
}

ComponentRouter.propTypes = {
  dispatch: PropTypes.func.isRequired,
  userData: PropTypes.object,
  block: PropTypes.object,
  history: PropTypes.array,
  currentAction: PropTypes.string
};

export default connect(mapStateToProps)(ComponentRouter);

